// src/browser.ts
import DOMPurify from "dompurify";
var browser_default = DOMPurify;
var sanitize = DOMPurify.sanitize.bind(DOMPurify);
var isSupported = DOMPurify.isSupported;
var addHook = DOMPurify.addHook.bind(DOMPurify);
var removeHook = DOMPurify.removeHook.bind(DOMPurify);
var removeHooks = DOMPurify.removeHooks.bind(DOMPurify);
var removeAllHooks = DOMPurify.removeAllHooks.bind(DOMPurify);
var setConfig = DOMPurify.setConfig.bind(DOMPurify);
var clearConfig = DOMPurify.clearConfig.bind(DOMPurify);
var isValidAttribute = DOMPurify.isValidAttribute.bind(DOMPurify);
var version = DOMPurify.version;
var removed = DOMPurify.removed;
function clearWindow() {
}
export {
  addHook,
  clearConfig,
  clearWindow,
  browser_default as default,
  isSupported,
  isValidAttribute,
  removeAllHooks,
  removeHook,
  removeHooks,
  removed,
  sanitize,
  setConfig,
  version
};
